import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RouteKeys} from '../../constants';
import {ValidationService, StringService} from '../../services';
import {InputText, ScreenNotificationDefault, Footer} from '../../components';
import validation from './validation';
import validationEmployee from './validationEmployee';
import {
  redirectToDataResidential,
  redirectToPhotoTime,
} from '../../ducks/Navigate';
import {updateProfissao, profissaoAdicionar} from '../../ducks/Customer';
import {tiposProfissoesBuscar, profissoesBuscar} from '../../ducks/Select';

import Select from 'react-select';
import {SelectStyles} from '../../constants';

import './styles.scss';

class DataProfessional extends Component {
  async componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.DataProfessional.title,
    );
    this.props.tiposProfissoesBuscar();
    this.props.profissoesBuscar();
  }

  formIsValid = () => ValidationService.validate(this.props, validation);

  handleSubmit = (event) => {
    event.preventDefault();

    console.log(
      'Dados preenchidos no formulário do data-professional: ',
      this.props,
    );

    if (
      this.props.tipo === 'Funcionário Privado' ||
      this.props.tipo === 'Funcionário Público'
    ) {
      if (!ValidationService.validate(this.props, validationEmployee)) return;
    } else {
      if (!ValidationService.validate(this.props, validation)) return;
    }

    let chave = this.props.chave;

    this.props.profissaoAdicionar({
      chave,
      ...this.props,
    });
  };

  handleChange = (prop, value) => {
    this.props.updateProfissao({prop, value});
  };

  renderEmpresa = () => {
    return (
      <InputText
        type="text"
        id="empresa"
        name="empresa"
        value={this.props.empresa}
        maxLength="100"
        onChange={(ev) => this.handleChange('empresa', ev.target.value)}
        placeholder="Empresa"
      />
    );
  };
  renderFone = () => {
    return (
      <InputText
        type="tel"
        id="telefone"
        name="telefone"
        value={this.props.telefone}
        onChange={(ev) => this.handleChange('telefone', ev.target.value)}
        placeholder="DDD + Telefone Fixo (Opcional)"
        mask="(99) 9999-9999"
      />
    );
  };
  renderAdmissao = () => {
    return (
      <InputText
        type="tel"
        id="admissao"
        name="admissao"
        mask="99/99/9999"
        value={this.props.admissao}
        onChange={(ev) => this.handleChange('admissao', ev.target.value)}
        placeholder="Data Admissão"
      />
    );
  };

  limparPropriedades = () => {
    this.handleChange('nome', '');
    this.handleChange('empresa', '');
    this.handleChange('telefone', '');
    this.handleChange('admissao', '');
  };

  render() {
    return (
      <ScreenNotificationDefault
        title={<p>Dados Profissionais</p>}
        contentCustom={
          <form className="form" id="frm" onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label htmlFor="tipoProfissao" className="form-label">
                Natureza da Ocupação
              </label>

              <Select
                className="select-input"
                isSearchable={true}
                isClearable={true}
                id="tipoProfissao"
                name="tipoProfissao"
                required
                styles={SelectStyles}
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                placeholder="Selecione..."
                value={
                  this.props.tipo
                    ? {
                        label: this.props.tipo,
                        value: this.props.tipo,
                      }
                    : ''
                }
                onChange={(ev) => {
                  this.handleChange('tipo', ev ? ev.value : '');
                  this.limparPropriedades();
                }}
                options={
                  this.props.tiposProfissoes &&
                  this.props.tiposProfissoes.map((tipoProfissao, indice) => ({
                    label: tipoProfissao.nome,
                    value: tipoProfissao.nome,
                    key: indice,
                  }))
                }
              />
            </div>
            <div className="form-group">
              <label htmlFor="profissao" className="form-label">
                Profissão
              </label>

              <Select
                className="select-input"
                isSearchable={true}
                isClearable={true}
                isDisabled={this.props.tipo ? false : true}
                id="profissao"
                name="profissao"
                required
                styles={SelectStyles}
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                placeholder="Selecione..."
                value={
                  this.props.nome
                    ? {
                        label: this.props.nome,
                        value: this.props.nome,
                      }
                    : ''
                }
                onChange={(ev) => {
                  this.handleChange('nome', ev ? ev.value : '');
                }}
                options={
                  this.props.tipo &&
                  this.props.profissoes &&
                  this.props.profissoes
                    .filter((profissao) => profissao.tipo === this.props.tipo)
                    .map((profissao, indice) => ({
                      label: profissao.nome,
                      value: profissao.nome,
                      key: indice,
                    }))
                }
              />
            </div>
            {this.props.tipo === 'Funcionário Público' ||
            this.props.tipo === 'Funcionário Privado'
              ? this.renderEmpresa()
              : ''}
            {this.props.tipo === 'Funcionário Público' ||
            this.props.tipo === 'Funcionário Privado'
              ? this.renderFone()
              : ''}
            {this.props.tipo === 'Funcionário Público' ||
            this.props.tipo === 'Funcionário Privado'
              ? this.renderAdmissao()
              : ''}

            <InputText
              type="tel"
              id="rendaMensal"
              name="rendaMensal"
              maxLength="13"
              decimalSeparator={','}
              thousandSeparator={'.'}
              prefix={'R$'}
              fixedDecimalScale
              decimalScale={2}
              value={this.props.rendaMensal}
              onChange={(ev) =>
                this.handleChange('rendaMensal', ev.target.value)
              }
              placeholder="Renda Mensal"
            />
          </form>
        }
        contentButtons={
          <div className="div-data-professional">
            <Footer
              backHandle={() => {
                this.props.redirectToDataResidential();
              }}
              nextForm="frm"
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer, select}) => {
  const {chave, profissao} = customer;
  const {tiposProfissoes, profissoes} = select;
  console.log(customer.profissao);
  return {chave, ...profissao, tiposProfissoes, profissoes};
};

export default connect(mapStateToProps, {
  redirectToDataResidential,
  redirectToPhotoTime,
  profissaoAdicionar,
  updateProfissao,
  tiposProfissoesBuscar,
  profissoesBuscar,
})(DataProfessional);
